<template>
  <div class="policy-page pk-account-panel">
    <section class="policy-hero">
      <div>
        <span>{{ page.eyebrow }}</span>
        <h1>{{ page.title }}</h1>
        <p>{{ page.lead }}</p>
      </div>
      <div class="hero-card">
        <img src="../assets/hotpizza/pizzaking-logo.svg" alt="pizzaking" />
        <strong>pizzaking</strong>
        <em>{{ page.sourceLabel }}</em>
      </div>
    </section>

    <section class="policy-card">
      <article v-for="(section, index) in page.sections" :key="section.title" class="policy-section">
        <div class="section-index">{{ index + 1 }}</div>
        <div>
          <h2>{{ section.title }}</h2>
          <p>{{ section.text }}</p>
        </div>
      </article>
    </section>

    <section class="policy-footer">
      <div>
        <span>PizzaKing 政策中心</span>
        <p>法律与政策页面统一使用共享外壳、暗色卡片布局与清晰的阅读层级，帮助你快速了解本站规则。</p>
      </div>
      <button @click="$router.push('/Doubt')">常见问题</button>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="less" scoped>
.policy-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 96px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 138, 31, 0.16), transparent 32%),
    radial-gradient(circle at 86% 20%, rgba(0, 217, 255, 0.08), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.policy-hero,
.policy-card,
.policy-footer {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.policy-hero {
  min-height: 320px;
  padding: 44px;
  display: grid;
  grid-template-columns: 1fr 310px;
  gap: 24px;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    radial-gradient(circle at 78% 46%, rgba(255, 138, 31, 0.22), transparent 34%),
    linear-gradient(135deg, rgba(43, 46, 61, 0.98), rgba(24, 26, 36, 0.98));
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.policy-hero::after {
  content: "";
  width: 620px;
  height: 190px;
  position: absolute;
  right: -150px;
  bottom: -92px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.035);
}

.policy-hero span,
.policy-footer span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.policy-hero h1 {
  max-width: 760px;
  margin: 14px 0 16px;
  color: #f8fbff;
  font-size: 64px;
  line-height: 0.96;
  font-weight: 1000;
}

.policy-hero p,
.policy-section p,
.policy-footer p {
  color: #aeb6c8;
  font-size: 16px;
  line-height: 1.78;
  font-weight: 800;
}

.hero-card {
  min-height: 230px;
  display: grid;
  place-items: center;
  text-align: center;
  position: relative;
  z-index: 1;
  border-radius: 18px;
  background: radial-gradient(circle, rgba(255, 138, 31, 0.24), transparent 68%), rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.hero-card img {
  width: 148px;
  filter: drop-shadow(0 18px 32px rgba(0, 0, 0, 0.44));
}

.hero-card strong {
  color: #f8fbff;
  font-size: 24px;
  font-weight: 1000;
}

.hero-card em {
  max-width: 220px;
  color: #8f98ac;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
}

.policy-card {
  margin-top: 22px;
  padding: 18px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.96), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.policy-section {
  padding: 20px;
  display: grid;
  grid-template-columns: 54px 1fr;
  gap: 18px;
  border-radius: 12px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
}

.policy-section + .policy-section {
  margin-top: 12px;
}

.section-index {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border-radius: 50%;
  font-size: 18px;
  font-weight: 1000;
}

.policy-section h2 {
  margin: 0;
  color: #f8fbff;
  font-size: 24px;
  font-weight: 1000;
}

.policy-section p {
  margin: 10px 0 0;
}

.policy-footer {
  margin-top: 22px;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.96), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.policy-footer button {
  height: 42px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
}

@media screen and (max-width: 1080px) {
  .policy-page {
    padding: 20px 12px 64px;
  }

  .policy-hero {
    grid-template-columns: 1fr;
  }

  .policy-hero h1 {
    font-size: 46px;
  }

  .policy-section {
    grid-template-columns: 1fr;
  }

  .policy-footer {
    display: block;
  }
}
</style>
